import React from "react";
import Grid from "@mui/material/Grid";
import { Box, Card } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronsRight } from "@fortawesome/pro-solid-svg-icons";
import { useContentByStatus } from "../creatorServices";

const useStyles = makeStyles(theme => ({
  root: {
    // minHeight: 185,
    width: "100%",
    padding: theme.spacing(4),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    borderRadius: 20,
    color: theme.palette.secondary.contrastText,
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
  },

  count: {
    marginRight: theme.spacing(1),
  },

  h1: {
    // fontSize: "6.0rem",
    fontSize: "3.8rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },

  h4: {
    // fontSize: "1.8rem",
    fontSize: "1.4rem",
    lineHeight: "2.2rem",
    fontWeight: "bold",
    color: theme.palette.primary.main,
  },

  body1: {
    fontSize: "1.2rem",
    textTransform: "uppercase",
  },

  body2: {
    fontSize: "1.2rem",
    lineHeight: "1.8rem",
    fontStyle: "italic",
  },

  icon: {
    fontSize: "0.9rem",
    marginTop: 2,
    marginLeft: 5,
    color: theme.palette.primary.main,
  },
}));

const UnorganizedItemsCard = () => {
  const classes = useStyles();
  const searchResults = useContentByStatus({
    status: "approved",
    limit: "all",
    hasParent: false,
  });

  return (
    <Link to="/creator/organize?view=organize,organize-ungrouped">
      <Card classes={{ root: classes.root }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography
              variant="h4"
              component="span"
              classes={{ h4: classes.h4 }}
            >
              Unorganized Files
            </Typography>
          </Grid>
        </Grid>

        {searchResults.isSuccess ? (
          <Box mt="20px" display="flex" flexDirection="column">
            <Typography
              variant="h1"
              component="p"
              classes={{ root: classes.count, h1: classes.h1 }}
            >
              {searchResults.data.count.toLocaleString()}
            </Typography>

            <Box display="flex" alignItems="center">
              <Typography
                component="p"
                variant="h4"
                classes={{ h4: classes.h4 }}
              >
                Organize
              </Typography>
              <FontAwesomeIcon
                className={classes.icon}
                icon={faChevronsRight}
              />
            </Box>
          </Box>
        ) : (
          <Box>
            <Typography
              variant="h4"
              component="span"
              classes={{ h4: classes.h4 }}
            >
              Loading...
            </Typography>
          </Box>
        )}
      </Card>
    </Link>
  );
};

export default UnorganizedItemsCard;
